
import { Component, input, output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { NumberFormatDirective } from '@fitness-force/directives';
import { StyleClassModule } from 'primeng/styleclass';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.css'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    StyleClassModule,
    TranslateModule,
    NumberFormatDirective
]
})
export class InputNumberComponent {
  readonly formGroup = input<UntypedFormGroup>(new UntypedFormGroup({}));
  readonly controlName = input<UntypedFormControl>(new UntypedFormControl());
  readonly styleClass = input<string>("w-full text-sm");
  readonly placeholder = input<string>("");
  readonly conditionToFormat = input<boolean>(false); 
  readonly mode = input<string>("decimal"); 
  readonly maxlength = input<number>(100);
  readonly maxFractionDigits = input<number>(2);
  readonly onBlur = output<string>();


  onBlurEvent(event:any)
  {
      this.onBlur.emit(event);
  }


}
